import { motion } from "framer-motion";
import "./contact.css";
import { useState, useEffect } from "react";

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { y: 30, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};

const formItemVariants = {
  hidden: { x: -20, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: "backOut"
    }
  }
};

const infoBoxVariants = {
  hidden: { scale: 0.95, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.7,
      ease: "circOut"
    }
  }
};

export default function ContactUsPage() {
  const [mobileVersion, setMobileVersion] = useState(window.innerWidth <= 767);

  useEffect(() => {
    function handleResize() {
      setMobileVersion(window.innerWidth <= 767);
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Form state
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [source, setSource] = useState('');
  const [message, setMessage] = useState('');

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    const subject = encodeURIComponent(`Message from ${fullName}`);
    const body = encodeURIComponent(
      `Name: ${fullName}\nEmail: ${email}\nHow did you hear about us: ${source}\n\nMessage:\n${message}`
    );

    window.location.href = `mailto:contact@cae-company.com?subject=${subject}&body=${body}`;
  };

  // Handle email click
  const handleEmailClick = () => {
    window.location.href = "mailto:contact@cae-company.com";
  };

  return (
    <motion.div 
      className={mobileVersion ? "mob-contact-page" : "contact-page"}
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.h1 className="contact-title" variants={itemVariants}>
        CONTACT US<div className="contact-divider" />
      </motion.h1>

      <motion.div className="contact-container" variants={containerVariants}>
        {/* Write to Us Form */}
        <motion.div className="contact-form-section" variants={itemVariants}>
          <motion.h2 className="form-title" variants={itemVariants}>
            WRITE TO US
          </motion.h2>
          <motion.p className="form-subtitle" variants={itemVariants}>
            kindly complete the form below and send us your message...
          </motion.p>

          <motion.form className="contact-form" variants={containerVariants} onSubmit={handleSubmit}>
            <motion.div className="input-row" variants={formItemVariants}>
              <input
                type="text"
                placeholder="full name"
                className="input-half"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
              <input
                type="email"
                placeholder="email"
                className="input-half"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </motion.div>

            <motion.input
              type="text"
              placeholder="how did you hear about us?"
              className="input-full"
              value={source}
              onChange={(e) => setSource(e.target.value)}
              variants={formItemVariants}
            />

            <motion.textarea
              placeholder="your message..."
              className="textarea-full"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              variants={formItemVariants}
            />

            <motion.button
              type="submit"
              className="submit-button"
              variants={formItemVariants}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
            >
              SUBMIT
            </motion.button>
          </motion.form>
        </motion.div>

        {/* Contact Info */}
        <motion.div className="contact-info" variants={containerVariants}>
          <motion.div className="info-box" variants={infoBoxVariants}>
            <h3>VIENNA HEADQUARTER</h3>
            <p>Hohenauergasse 8/5 <br/> 1190 Vienna <br/> Austria</p>
          </motion.div>
          <motion.div className="info-box" variants={infoBoxVariants}>
            <h3>OUR CONTACT EMAIL</h3>
            <p 
              onClick={handleEmailClick}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              contact@cae-company.com
            </p>
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}